import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Elige tu plan inicial <br/> Nosotros nos encargamos de todo, <underline>TÚ</underline> relájate 🚀',
  billing_modes: {
    [BillingMode.InternalInvoicing]: 'Pagar después de las ventas',
    [BillingMode.Stripe]: '(0)[Pagar ahora];(1-inf)[Pagar ahora (ahorra hasta {{discount}})]',
  },
};
